/**
 * Router-shell do modulo Kanbans (Fase 6).
 *
 * Sub-rotas:
 *   /kanbans         -> Lista
 *   /kanbans/:id     -> Board (drag-drop)
 */
import React from "react";
import { Route, Routes } from "react-router-dom";

import Board from "./Board";
import Lista from "./Lista";

function KanbansShell() {
  return (
    <Routes>
      <Route index element={<Lista />} />
      <Route path=":kanbanId" element={<Board />} />
    </Routes>
  );
}

export default KanbansShell;
